import { useQueryClient } from "@tanstack/react-query";
import { Link, useNavigate, useSearch } from "@tanstack/react-router";

import { forgetMediaAccess } from "../../platform/media/access";
import { wayBack } from "../../platform/session";
import { AuthSecondaryButton, AuthShell } from "../../ui/AuthShell";
import { SignInChoices } from "./SignInChoices";

/** Shared authentication entry. Account creation remains the server's policy. */
export function SignInScreen() {
  const { redirect } = useSearch({ from: "/sign-in" });
  return <AuthEntry target={wayBack(redirect)} signup={false} />;
}

export function SignUpScreen() {
  const { redirect } = useSearch({ from: "/sign-up" });
  return <AuthEntry target={wayBack(redirect)} signup />;
}

function AuthEntry({ target, signup }: { target: string; signup: boolean }) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const onSignedIn = () => {
    // A new session: nothing cached under the old one may show (audit frontend B.9), and no
    // media grant of it is asked on.
    queryClient.clear();
    forgetMediaAccess();
    void navigate({ href: target, replace: true });
  };
  return (
    <AuthShell title={signup ? "Create your account" : "Welcome back"}>
      <SignInChoices redirect={target} divider={signup ? "or sign up with email" : "or log in with email"}
        onSignedIn={onSignedIn} {...(signup ? { footer: "Create an account with Google or an email code." } : {})} />
      <AuthSecondaryButton renderRoot={(props) => (
        <Link {...props} to={signup ? "/sign-in" : "/sign-up"} search={{ redirect: target }} />
      )}>
        {signup ? "Already have an account? Log in" : "Create an account"}
      </AuthSecondaryButton>
    </AuthShell>
  );
}
